export enum RowStatus {
    Active = 1,
    InActive = 2,
    Delete = 3,
    Clear = 4,
    InComplete=5
  }

  export enum MemberActivityLogType {
    Impersonation_Started = 1,
    Impersonation_Failed = 2,
    Impersonation_Ended = 3,
    Email_New = 4,
    DisplayName_Updated = 5,
    DisplayName_Deleted = 6,
    Phone_Updated = 7,
    PreferenceLanguage_Updated = 8,
    RegisteredAddress_Updated = 9,
    InstantAuthorization_Updated = 10,
    SponsorChange = 11,
    Upgraded_flag = 12,
    MemberLevel_change = 13,
    DisplayPicture_New = 14,
    DisplayPicture_Updated = 15,
    DisplayPicture_Deleted = 16,
    CreditCard_SetAsDefault = 17,
    CreditCard_New = 18,
    CreditCard_Deleted = 19,
    Personalcheck_SetAsDefault = 20,
    NewPersonacheck_Added = 21,
    Personalcheck_Deleted = 22,
    Address_DefaultMailing = 23,
    Address_New = 24,
    Address_Updated = 25,
    Address_Deleted = 26,
    Document_Accept = 27,
    Document_Skip = 28,
    Document_View = 29,
    Opted_ContactedBySponsor_Email = 30,
    Opted_ContactedBySponsor = 31,
    PasswordReset_Emailed = 32,
    Homecountry_Updated = 33,
    Personalecheck_Updated = 34,
    OptedIn_NotifyPromotions = 35,
    OptedOut_NotifyPromotions = 36,
    Unlock_Account = 37,
    Change_Status = 38,
    Change_Government_ID = 39,
    Change_Business_Entity = 40,
    Change_DOB = 41,
    Change_Temporary_PWD = 42,
    Attachment = 43,
    Phone_Type_Updated = 44,
    Account_Notification_Created = 45,
    Account_Notification_Updated = 46,
    Account_Notification_Disabled = 47,
    Member_Email_Resent = 51,
    Member_CC_Limit_Override_Updated = 49,
    Member_CC_Limit_Override_Disabled = 50,
    Flp360_Impersonation_Started = 52,
    Member_First_Name_Updated = 53,
    Member_Middle_Name_Updated = 54,
    Member_Last_Name_Updated = 55,
    Flp360_Password_Reset_Emailed = 56,
    Flp360_Change_Temporary_Password = 57,
    Upline_Report_Attachment = 58,
    New_Guest_Retail_Created = 59,
    New_Retail_Created = 60,
    Note = 62,
    Member_Preference_Updated = 64,
    Amazon_Subscription_Updated = 65,
    New_FPC_Created = 66,
    New_FBO_Created = 67,
    GovernmentID_Created= 68,
    GovernmentID_Updated= 69,
    GovernmentID_Deleted= 70,
    Sponsor_Update = 71,
    Override_Minimum_Limit=72,
    PCSponsor_Eligibility_Updated=75,
}

export enum MemberActivityLogPortal {
    CustomerService = 1,
    Impersonation = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/common/enumerations.ts